import { Kit, KitContent, KitProductGroup } from '../../types/graphql'

import { testimonial } from './sections'
import { collection, product, productGroupWithProductAvailability, variant } from './unorganized'

// "Kit" in Contentful
export const kitContent: KitContent = {
  handle: 'womens-livingston-starter-kit',
  testimonials: [testimonial, testimonial, testimonial],
  testimonialsTitle: 'Awesome Humans',
  testimonialsSubtitle: 'Ipsum elit nisi ea officia laboris id dolor ad ut adipisicing amet.',
  sections: [
    {
      __typename: 'RawHtmlSection',
      id: 'Test Html Section',
      html: '<section class="did-you-know"><h2 class="did-you-know-title">Our Mission</h2><p data-testid="did-you-know-text" class="did-you-know-subtitle"> We believe every medical professional should have access to scrubs.</p><div class="stat-container"><div class="stat-list"><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-earth.png?v=1614627000" alt="" /><p class="title">COUNTRIES WHERE WE’VE DONATED:</p><p class="stat">35</p></div></div><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-hands.png?v=1614627000" alt="" /><p class="title">ORGANIZATIONS WE’VE PARTNERED WITH:</p><p class="stat">60</p></div></div><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-heart.png?v=1614627000" alt="" /><p class="title">IMPACT OF A SET OF FIGS:</p><p class="stat">INVALUABLE</p></div></div></div></div> </section><style>section.did-you-know{margin:2rem 0;display:flex;flex-direction:column;justify-content:center;text-align:center;padding:0 24px}section.did-you-know .did-you-know-title{font-size:18px;font-weight:700;letter-spacing:2px;line-height:11px;text-align:center;margin-bottom:32px;text-transform:uppercase}section.did-you-know .did-you-know-subtitle{font-size:14px}section.did-you-know .stat-container{padding:4rem 0 5rem 0}section.did-you-know .stat-list{display:flex;flex-direction:column;justify-content:center}section.did-you-know img{height:80px;width:80px;margin:0 auto 20px}section.did-you-know .title{flex-direction:row;color:#707070;text-transform:uppercase;letter-spacing:1px;line-height:1.82;font-weight:600;font-size:11px;max-width:150px;margin:auto auto 1rem auto}section.did-you-know .stat{color:#707070;font-weight:600;font-size:1.1rem;letter-spacing:1px}@media (min-width: 810px){section.did-you-know{margin:4rem 0}section.did-you-know .stat-list{flex-direction:row}section.did-you-know .stat-item{padding:0 3rem}}</style>',
    },
  ],
  groupItemsByColor: true,
  defaultColors: "{ 'some-product-handle': 'Black' }",
  hideProductDetails: false,
}

export const kit: Kit = {
  productGroup: {
    ...productGroupWithProductAvailability,
    handle: 'womens-livingston-starter-kit',
    defaultVariant: {
      ...variant,
      price: 5000,
      sku: 'sdf',
    },
    products: [
      {
        ...product,

        title: "Women's Livingston Starter Kit",
        description: 'Livingston™ Starter Kit',
        whyWeLove:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam ex elit, semper eget congue a, commodo et sem. Aliquam id venenatis diam, in dapibus lectus. Sed feugiat sed risus ac scelerisque.',
        badgeList: [],
        fitModelsDescriptions: [],
        rawMaterials: [],
        iconList: [
          {
            id: '9',
            label: 'Lauren',
            image:
              'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
            title: 'MODEL IS: XS / 5"8"',
          },
          {
            id: '10',
            label: '3 pockets',
            image:
              'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
            title: '3 pockets',
          },
        ],
        images: {
          nodes: [
            {
              id: 'id-1',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 1,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/3101/9164/products/Livingston-basic-scrub-pants_burgundy-1.jpg',
            },
            {
              id: 'id-2',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 2,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/3101/9164/products/Livingston-basic-scrub-pants_burgundy-2.jpg',
            },
            {
              id: 'id-3',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 3,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/zamora_heatheredindigo_5_i_33f1382f-91cb-4aec-b4f7-58766bfa53f0.jpg',
            },
            {
              id: 'id-4',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 4,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/Zamora-jogger-pant_5_4ba6c285-5f32-47bd-9c13-e3973a3d1c1d.jpg',
            },
            {
              color: 'Graphite',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              fit: 'petite',
              id: 'id-5',
              index: 5,
              kind: 'wwlt',
              name: null,
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/Whywelovethis_axim.jpg?v=1609984453',
              type: 'ProductImage',
            },
          ],
        },
        noindex: true,
        videos: {
          nodes: [],
        },
      },
    ],
  },
  collection: {
    ...collection,
    handle: 'womens-livingston-starter-kit',
    name: "Women's Livingston Starter Kit",
    productGroups: [productGroupWithProductAvailability, productGroupWithProductAvailability],
  },
}
interface kitSet {
  [key: string]: {
    collection: {
      productGroups: readonly KitProductGroup[]
      productHandles: readonly string[]
    }
  }
}

export const mensSetKit: kitSet = {
  'mens-other-scrub-tops-carousel': {
    collection: {
      productHandles: [
        'mens-chisec-three-pocket-scrub-top-navy',
        'mens-leon-slim-scrub-top-black',
        'mens-chisec-three-pocket-scrub-top-royal-blue',
        'mens-lima-ss-polo-scrub-top-black',
        'mens-leon-slim-scrub-top-navy',
        'mens-chisec-three-pocket-scrub-top-graphite',
        'mens-chisec-three-pocket-scrub-top-black',
        'mens-chisec-three-pocket-scrub-top-burgundy',
        'mens-classic-leon-utility-cargo-contrast-scrub-top-navy',
        'mens-chisec-three-pocket-scrub-top-ceil-blue',
      ],
      productGroups: [
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'graphite',
            },
            {
              handle: 'ceil-blue',
            },
            {
              handle: 'royal-blue',
            },
            {
              handle: 'burgundy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-chisec-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-chisec-three-pocket-scrub-top-black',
              id: 'p7c2ca2c5f749ee1c',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q2_2022_05_BLACK_CHISEC_M_MOOSE_31893.jpg?v=1677877013',
                  },
                ],
              },
            },
            {
              color: 'Burgundy',
              handle: 'mens-chisec-three-pocket-scrub-top-burgundy',
              id: 'p45aeb8ec8af4f304',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Chisec-Scrub-Top-Burgundy-1.jpg?v=1659047965',
                  },
                ],
              },
            },
            {
              color: 'Ceil Blue',
              handle: 'mens-chisec-three-pocket-scrub-top-ceil-blue',
              id: 'pc13895dfabf71919',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_02_CEIL-BLUE_CHISEC_CORE-REFRESH_M_COREY_41347.jpg?v=1679698914',
                  },
                ],
              },
            },
            {
              color: 'Graphite',
              handle: 'mens-chisec-three-pocket-scrub-top-graphite',
              id: 'pc964236f684d18c6',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q2_CHISEC_CAIRO_GRAPHITE_CHRIS_12637_a6871722-8e16-4927-9f78-02368ff670ba.jpg?v=1675468887',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-chisec-three-pocket-scrub-top-navy',
              id: 'p146356291e5cc8dd',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Chisec-Navy-M-1.jpg?v=1674113294',
                  },
                ],
              },
            },
            {
              color: 'Royal Blue',
              handle: 'mens-chisec-three-pocket-scrub-top-royal-blue',
              id: 'p758ad6fe0c5aef5d',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_02_ROYAL-BLUE_CHISEC_CORE-REFRESH_M_MOOSE_38214.jpg?v=1680032894',
                  },
                ],
              },
            },
          ],
          title: "Men's Chisec™ Three-Pocket Scrub Top",
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-leon-slim-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-leon-slim-scrub-top-black',
              id: 'pf2d3be0558149905',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_12_BLACK_LEON-SLIM-CORE_M_NORBI_10407.jpg?v=1673565457',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-leon-slim-scrub-top-navy',
              id: 'p4d8f53de2201e7af',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_12_NAVY_LEONSLIM_M_MOOSE_15610.jpg?v=1673564634',
                  },
                ],
              },
            },
          ],
          title: 'Slim Leon™ - Three-Pocket Scrub Top',
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-lima-ss-scrub-polo',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-lima-ss-polo-scrub-top-black',
              id: 'pac2c8d2b90f4b939',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Lima-SS-Polo-Top-black-1.jpg?v=1634935426',
                  },
                ],
              },
            },
          ],
          title: 'Lima Shortsleeve ScrubPolo™ ',
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'navy-blue',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-classic-leon-cargo-utility-contrast-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Navy/Blue',
              handle: 'mens-classic-leon-utility-cargo-contrast-scrub-top-navy',
              id: 'pe960dc6c5f42eac0',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q4_2022_11_NAVY_LEON-UTILITY-CARGO-CONTRAST_M_COREY_00288.jpg?v=1674858960',
                  },
                ],
              },
            },
          ],
          title: 'Leon™ Cargo Scrub Top',
        },
      ],
    },
  },
  'mens-other-scrub-pants-carousel': {
    collection: {
      productHandles: [
        'mens-tansen-slim-jogger-scrub-pants-black',
        'mens-cairo-cargo-scrub-pants-royal-blue',
        'mens-cairo-slim-cargo-scrub-pants-navy',
        'mens-pisco-basic-scrub-pants-black',
        'mens-tansen-slim-jogger-scrub-pants-navy',
        'mens-cairo-cargo-scrub-pants-black',
        'mens-cairo-cargo-scrub-pants-burgundy',
        'mens-axim-cargo-scrub-pants-black',
        'mens-cairo-cargo-scrub-pants-graphite',
        'mens-cairo-cargo-scrub-pants-navy',
        'mens-cairo-cargo-scrub-pants-ceil-blue',
        'mens-pisco-basic-scrub-pants-navy',
      ],
      productGroups: [
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-tansen-slim-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-tansen-slim-jogger-scrub-pants-black',
              id: 'pdea6a2e2d24806ae',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_12_BLACK_TANSENSLIM_M_MOOSE_15555.jpg?v=1673563935',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-tansen-slim-jogger-scrub-pants-navy',
              id: 'p5e20836bf8d9e74a',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_12_NAVY_TANSEN-SLIM-CORE_M_NORBI_10541_fee76831-aced-4132-895c-e0c99142263f.jpg?v=1673564516',
                  },
                ],
              },
            },
          ],
          title: 'Slim Tansen™ Jogger Scrub Pants',
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'graphite',
            },
            {
              handle: 'ceil-blue',
            },
            {
              handle: 'royal-blue',
            },
            {
              handle: 'burgundy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-cairo-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-cairo-cargo-scrub-pants-black',
              id: 'p60023041ccd25719',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cairo-Black-M-1.jpg?v=1671148456',
                  },
                ],
              },
            },
            {
              color: 'Burgundy',
              handle: 'mens-cairo-cargo-scrub-pants-burgundy',
              id: 'pd05ea51df2fa9f32',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cairo-Scrub-Pant-Burgundy-1.jpg?v=1675711128',
                  },
                ],
              },
            },
            {
              color: 'Ceil Blue',
              handle: 'mens-cairo-cargo-scrub-pants-ceil-blue',
              id: 'pa2c1804c0dea3432',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_02_CEIL-BLUE_CAIRO_CORE-REFRESH_M_MOOSE_38381.jpg?v=1680032816',
                  },
                ],
              },
            },
            {
              color: 'Graphite',
              handle: 'mens-cairo-cargo-scrub-pants-graphite',
              id: 'p5d8b9f8cae3349f7',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cairo-Graphite-M-1_ae9e7504-5d4b-44b2-9540-a77d0b833d25.jpg?v=1671213656',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-cairo-cargo-scrub-pants-navy',
              id: 'p6bd6ebd835224054',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cairo-Navy-M-1.jpg?v=1671139883',
                  },
                ],
              },
            },
            {
              color: 'Royal Blue',
              handle: 'mens-cairo-cargo-scrub-pants-royal-blue',
              id: 'p9d7e47455375ec7d',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cairo-Scrub-Pant-RoyalBlue-1.jpg?v=1659049027',
                  },
                ],
              },
            },
          ],
          title: "Men's Cairo™ Cargo Scrub Pants",
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4400,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-pisco-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-pisco-basic-scrub-pants-black',
              id: 'pfa56187d469420ab',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-PiscoBlack-M-1.jpg?v=1675387967',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-pisco-basic-scrub-pants-navy',
              id: 'pb36d49f234e63cd7',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Pisco-Scrub-Pants_navy-1.jpg?v=1602741838',
                  },
                ],
              },
            },
          ],
          title: "Men's Pisco™ Basic Scrub Pants",
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-axim-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-axim-cargo-scrub-pants-black',
              id: 'p63bf99d30cfb4e92',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Axim-Scrub-Pant-black-1_1c398e0f-1f6a-4214-b28a-cff90d18567e.jpg?v=1647467120',
                  },
                ],
              },
            },
          ],
          title: "Men's Axim™ Cargo Scrub Pants",
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-cairo-slim-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Navy',
              handle: 'mens-cairo-slim-cargo-scrub-pants-navy',
              id: 'p24f7dfae35353461',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_12_NAVY_CAIROSLIM_M_MOOSE_15667.jpg?v=1673564497',
                  },
                ],
              },
            },
          ],
          title: 'Slim Cairo™ Cargo Scrub Pants',
        },
      ],
    },
  },
  'mens-everything-else-carousel': {
    collection: {
      productHandles: [
        'mens-makato-crewneck-longsleeve-underscrub-new-black',
        'mens-on-shift-fleece-jacket-black',
        'mens-harlem-short-lab-coat-white',
        'mens-solid-compression-socks-grey',
        'mens-makato-crewneck-longsleeve-underscrub-new-graphite',
        'mens-cobaki-performance-scrub-jacket-navy',
        'mens-on-shift-fleece-jacket-navy',
        'unisex-modern-classic-scrub-cap-navy',
        'mens-super-soft-longsleeve-underscrub-black',
        'mens-essential-hoodie-heather-black',
        'mens-on-shift-fleece-jacket-deep-charcoal',
        'unisex-modern-classic-scrub-cap-black',
      ],
      productGroups: [
        {
          category: 'Underscrub',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'graphite',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 5800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-makato-underscrub',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-makato-crewneck-longsleeve-underscrub-new-black',
              id: 'p7a304363c010ac93',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Makato-Underscrub-Black-1.jpg?v=1654292482',
                  },
                ],
              },
            },
            {
              color: 'Graphite',
              handle: 'mens-makato-crewneck-longsleeve-underscrub-new-graphite',
              id: 'p63a2fce220e11305',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Makato-Performance-Underscrub-graphite-M-1.jpg?v=1655851816',
                  },
                ],
              },
            },
          ],
          title: 'Makato Performance Underscrub',
        },
        {
          category: 'Outerwear',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'deep-charcoal',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 9800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-on-shift-fleece-jacket',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-on-shift-fleece-jacket-black',
              id: 'p785213770b1530fb',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_02_BLACK_OS-FLEECE_CORE-REFRESH_M_COREY_41513.jpg?v=1679699502',
                  },
                ],
              },
            },
            {
              color: 'Deep Charcoal',
              handle: 'mens-on-shift-fleece-jacket-deep-charcoal',
              id: 'p61eff51db651eb00',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens_On-Shift-Fleece-JKT-Charcoal-1.jpg?v=1650672091',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'mens-on-shift-fleece-jacket-navy',
              id: 'p66a4d576c72755e7',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-On-Shift-Fleece-Jacket-navy-M-1.jpg?v=1665014811',
                  },
                ],
              },
            },
          ],
          title: "Men's On-Shift™ Fleece Jacket",
        },
        {
          category: 'Lab Coats',
          colors: [
            {
              handle: 'white',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 9800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-harlem-short-lab-coats',
          priceRangeByColors: {},
          products: [
            {
              color: 'White',
              handle: 'mens-harlem-short-lab-coat-white',
              id: 'p7a241c54e62f0f10',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-HarlemShortLabCoat-White-M-1.jpg?v=1658174935',
                  },
                ],
              },
            },
          ],
          title: "Men's White Harlem - Lab Coat",
        },
        {
          category: 'Socks',
          colors: [
            {
              handle: 'grey',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 2800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-grey-solid-socks',
          priceRangeByColors: {},
          products: [
            {
              color: 'Grey',
              handle: 'mens-solid-compression-socks-grey',
              id: 'p10eef97868da5f5a',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_12_GREY_COMPRESSIONSOCKS_M_GHOST_16697.jpg?v=1674077258',
                  },
                ],
              },
            },
          ],
          title: "Men's FIGS Compression Socks",
        },
        {
          category: 'Scrub Jacket',
          colors: [
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 9800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-cobaki-scrub-jacket',
          priceRangeByColors: {},
          products: [
            {
              color: 'Navy',
              handle: 'mens-cobaki-performance-scrub-jacket-navy',
              id: 'p733a67fc2a92b055',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens-Cobaki-Perf-Scrub-JKT-navy1.jpg?v=1650671256',
                  },
                ],
              },
            },
          ],
          title: "Men's Cobaki Scrub Jacket",
        },
        {
          category: 'Scrub Cap',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 1800,
                currency: 'USD',
              },
            },
          },
          handle: 'unisex-modern-classic-scrub-cap-scrub-cap',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'unisex-modern-classic-scrub-cap-black',
              id: 'p0b233732790a1a6f',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Black.jpg?v=1678738853',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'unisex-modern-classic-scrub-cap-navy',
              id: 'p7fad172b6202dbeb',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Modern-Classic-Scrub-Cap-navy-1.jpg?v=1678722631',
                  },
                ],
              },
            },
          ],
          title: 'Modern Scrub Cap',
        },
        {
          category: 'Underscrub',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-new-supersoft-longsleeve-underscrub',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-super-soft-longsleeve-underscrub-black',
              id: 'p2db5aff352c1ec96',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Mens_SUPERSOFT_Black_LS_1.jpg?v=1657667830',
                  },
                ],
              },
            },
          ],
          title: 'Men’s Supersoft Longsleeve Underscrub',
        },
        {
          category: 'Outerwear',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 6800,
                currency: 'USD',
              },
            },
          },
          handle: 'mens-essential-outerwear',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'mens-essential-hoodie-heather-black',
              id: 'p94102edf9e381c79',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_01_BLACK_ESSENTIAL-HOODIE_CORE-REFRESH_M_GABE_21570.jpg?v=1675277974',
                  },
                ],
              },
            },
          ],
          title: "Men's Essential Hoodie",
        },
      ],
    },
  },
}

export const womensSetKit: kitSet = {
  'womens-other-scrub-tops-carousel': {
    collection: {
      productHandles: [
        'womens-casma-three-pocket-scrub-top-navy',
        'womens-rafaela-mandarin-collar-scrub-top-black',
        'womens-rafaela-mandarin-collar-scrub-top-royal-blue',
        'womens-catarina-slim-scrub-top-black',
        'womens-casma-three-pocket-scrub-top-black',
        'womens-montex-classic-mock-neck-scrub-top-black',
        'womens-rafaela-mandarin-collar-scrub-top-navy',
        'womens-rafaela-mandarin-collar-scrub-top-burgundy',
        'womens-rafaela-mandarin-collar-scrub-top-graphite',
        'womens-casma-three-pocket-scrub-top-royal-blue',
        'womens-inala-slim-self-collar-scrub-top-navy',
        'womens-casma-three-pocket-scrub-top-burgundy',
      ],
      productGroups: [
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'royal-blue',
            },
            {
              handle: 'burgundy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-casma-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-casma-three-pocket-scrub-top-black',
              id: 'pcd8c3cd800e3eab5',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Casma-Top-Burgundy-XS-2_fb61f032-ccb9-455f-8d5b-ba0a6b92913a.jpg?v=1653606695',
                  },
                ],
              },
            },
            {
              color: 'Burgundy',
              handle: 'womens-casma-three-pocket-scrub-top-burgundy',
              id: 'pd5466d471415ca13',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Casma-Top-Burgundy-XS-1.jpg?v=1673566953',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-casma-three-pocket-scrub-top-navy',
              id: 'p181d9d4e53e7249d',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Casma-Top-Navy-XS-1.jpg?v=1676067901',
                  },
                ],
              },
            },
            {
              color: 'Royal Blue',
              handle: 'womens-casma-three-pocket-scrub-top-royal-blue',
              id: 'p827c19438b28aa86',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Women-Casma-Two-Pocket-Scrub-Top_royalblue-1.jpg?v=1650572661',
                  },
                ],
              },
            },
          ],
          title: "Women's Casma™ Three-Pocket Scrub Top",
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'graphite',
            },
            {
              handle: 'royal-blue',
            },
            {
              handle: 'burgundy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-rafaela-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-rafaela-mandarin-collar-scrub-top-black',
              id: 'pf405eaf32f721c7c',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-RAFAELA-Top-Black-XS-1.jpg?v=1653603050',
                  },
                ],
              },
            },
            {
              color: 'Burgundy',
              handle: 'womens-rafaela-mandarin-collar-scrub-top-burgundy',
              id: 'p01bd3af29a1c1efe',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Rafaela-Top-XL-burgundy-1.jpg?v=1654116525',
                  },
                ],
              },
            },
            {
              color: 'Graphite',
              handle: 'womens-rafaela-mandarin-collar-scrub-top-graphite',
              id: 'pfcead781412d3bfd',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Rafaela-Top-graphite-S-1.jpg?v=1650323477',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-rafaela-mandarin-collar-scrub-top-navy',
              id: 'p04199dd355b312b8',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-RAFAELA-Top-Navy-1.jpg?v=1653602779',
                  },
                ],
              },
            },
            {
              color: 'Royal Blue',
              handle: 'womens-rafaela-mandarin-collar-scrub-top-royal-blue',
              id: 'p432996fe1f06557a',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Rafaela-Mandarin-Scrub-Top_royalblue-1.jpg?v=1649116791',
                  },
                ],
              },
            },
          ],
          title: "Women's Rafaela™ Oversized Scrub Top",
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-catarina-slim-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-catarina-slim-scrub-top-black',
              id: 'pe1b99c5e4e464d58',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_11_BURGUNDY_CATARINA-SLIM_W_MAME_08585copy.jpg?v=1673536046',
                  },
                ],
              },
            },
          ],
          title:
            'Slim Catarina™ One-Pocket Scrub Top                                                                               ',
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-montex-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-montex-classic-mock-neck-scrub-top-black',
              id: 'p02e328096740bb76',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q4_2022_10_BLACK_MONTEX-CLASSIC-MOCK-NECK_W_DOMINIQUE_25428.jpg?v=1672342321',
                  },
                ],
              },
            },
          ],
          title: 'Montex Scrub Top',
        },
        {
          category: 'Scrub Top',
          colors: [
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4400,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-inala-slim-self-collar-scrub-top',
          priceRangeByColors: {},
          products: [
            {
              color: 'Navy',
              handle: 'womens-inala-slim-self-collar-scrub-top-navy',
              id: 'pe9e415d464275c44',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Inala-Navy-XS-1.jpg?v=1664997824',
                  },
                ],
              },
            },
          ],
          title: 'Inala Slim Scrub Top',
        },
      ],
    },
  },
  'womens-other-scrub-pants-carousel': {
    collection: {
      productHandles: [
        'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-black',
        'womens-yola-high-waisted-yoga-waistband-skinny-scrub-pants-navy',
        'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-royal-blue',
        'womens-kade-cargo-scrub-pants-black',
        'womens-livingston-basic-scrub-pants-navy',
        'womens-yola-high-waisted-yoga-waistband-skinny-scrub-pants-black',
        'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-navy',
        'womens-kade-cargo-scrub-pants-burgundy',
        'womens-new-yola-yoga-waistband-skinny-scrub-pants-black',
        'womens-livingston-high-waist-classic-scrub-pants-navy',
        'womens-livingston-high-waist-classic-scrub-pants-black',
        'womens-new-yola-yoga-waistband-skinny-scrub-pants-navy',
      ],
      productGroups: [
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
            {
              handle: 'royal-blue',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-zamora-high-waisted-yoga-waistband-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-black',
              id: 'pa8a9b8753b3473be',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-HW-Zamora-Pant-2.0-Black-1.jpg?v=1647995723',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-navy',
              id: 'p2301d90dc862746e',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-HW-Zamora-Pant-2.0-Navy-M-1_3e2dc89d-0488-46d5-b749-272201aa3723.jpg?v=1673547382',
                  },
                ],
              },
            },
            {
              color: 'Royal Blue',
              handle: 'womens-zamora-high-waisted-yoga-waistband-jogger-scrub-pants-royal-blue',
              id: 'p4dce16336b1b94d3',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-HW-Zamora-Pant-2.0-RoyalBlue-XS-1.jpg?v=1653602005',
                  },
                ],
              },
            },
          ],
          title: 'High Waisted Zamora™ Jogger Scrub Pants ',
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-yola-high-waisted-yoga-waistband-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-yola-high-waisted-yoga-waistband-skinny-scrub-pants-black',
              id: 'pfa05133d1d110797',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-HW-Yola-Pant-2.0-Black-XS-1_5247ed93-e194-41f4-905d-e5da6585d6db.jpg?v=1653603960',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-yola-high-waisted-yoga-waistband-skinny-scrub-pants-navy',
              id: 'pb132471dd05a9811',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-HW-Yola-Pant-2.0-NAVY-1_8d2e6c12-6c48-45f3-a2c7-6c0eec407f71.jpg?v=1654129333',
                  },
                ],
              },
            },
          ],
          title: 'High Waisted Yola™ Skinny Scrub Pants',
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'burgundy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-kade-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-kade-cargo-scrub-pants-black',
              id: 'p50072af6e55126b3',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Kade-Pant-Black-XS-1.jpg?v=1653518671',
                  },
                ],
              },
            },
            {
              color: 'Burgundy',
              handle: 'womens-kade-cargo-scrub-pants-burgundy',
              id: 'pf3244f406284ef58',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Kade-Pant-Burgundy-XS-1_cbf2dfec-e6f4-4512-ba93-18fb5bbc671d.jpg?v=1653518508',
                  },
                ],
              },
            },
          ],
          title: "Women's Kade™ Cargo Scrub Pants",
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4400,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-livingston-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Navy',
              handle: 'womens-livingston-basic-scrub-pants-navy',
              id: 'p231189660fe794d6',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Livingston-Pant-navy-S-1_61d97594-76d0-4171-bfeb-a0c1ece8e0be.jpg?v=1650387264',
                  },
                ],
              },
            },
          ],
          title: "Women's Livingston™ Basic Scrub Pants",
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-new-yola-yoga-waistband-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-new-yola-yoga-waistband-skinny-scrub-pants-black',
              id: 'p7b680fb29ef781eb',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q4_2021_10_BLACK_YOLA-YOGA_W_ALYSSAH_15192_d14dc167-393a-48c6-95c9-3d424ddbd373.jpg?v=1675457344',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-new-yola-yoga-waistband-skinny-scrub-pants-navy',
              id: 'p7f71419ba585eede',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q4_2021_10_NAVY_YOLA-YOGA_W_ALYSSAH_13899_9a19974f-9f33-4f75-968f-a9a14ae86a3e.jpg?v=1673384003',
                  },
                ],
              },
            },
          ],
          title: 'Yola™ Skinny Scrub Pants 2.0',
        },
        {
          category: 'Scrub Pants',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 4400,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-livingston-high-waisted-scrub-pants',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-livingston-high-waist-classic-scrub-pants-black',
              id: 'p068714e61a23d3a1',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Women-Livingston-High-Waisted-Scrub-Pant-black-1.jpg?v=1673566840',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-livingston-high-waist-classic-scrub-pants-navy',
              id: 'p6402f8e009438ec8',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Women-Livingston-High-Waisted-Scrub-Pant-navy-1.jpg?v=1641860197',
                  },
                ],
              },
            },
          ],
          title: "Women's High Waisted Livingston™  ",
        },
      ],
    },
  },
  'womens-everything-else-carousel': {
    collection: {
      productHandles: [
        'womens-salta-crewneck-longsleeve-underscrub-new-graphite',
        'womens-sydney-performance-scrub-jacket-black',
        'womens-double-stripe-compression-socks-navy',
        'womens-bellevue-long-slim-lab-coat-white',
        'womens-salta-crewneck-longsleeve-underscrub-new-black',
        'womens-on-shift-fleece-jacket-black',
        'unisex-new-canvas-tote-black',
        'unisex-modern-classic-scrub-cap-black',
        'womens-super-soft-longsleeve-black',
        'womens-bellery-scrub-jacket-black',
        'womens-sydney-performance-scrub-jacket-navy',
        'unisex-modern-classic-scrub-cap-navy',
      ],
      productGroups: [
        {
          category: 'Underscrub',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'graphite',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 5800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-salta-underscrub',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-salta-crewneck-longsleeve-underscrub-new-black',
              id: 'p9cfaaf04ecf37226',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Salta-Black-ALT-1.jpg?v=1654218341',
                  },
                ],
              },
            },
            {
              color: 'Graphite',
              handle: 'womens-salta-crewneck-longsleeve-underscrub-new-graphite',
              id: 'p65ddb7ce1eed153b',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Salta-Graphite-ALT-1.jpg?v=1654218414',
                  },
                ],
              },
            },
          ],
          title: "Women's Salta Performance Underscrub",
        },
        {
          category: 'Scrub Jacket',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 9800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-sydney-scrub-jacket',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-sydney-performance-scrub-jacket-black',
              id: 'pfafcfbf70dc908a7',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2023_02_BLACK_SYDNEY_CORE-REFRESH_W_MELANIE_46776.jpg?v=1680017176',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'womens-sydney-performance-scrub-jacket-navy',
              id: 'pedacc541c788ef10',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Sydney-Perf-Scrub-JKT-navy1.jpg?v=1650312795',
                  },
                ],
              },
            },
          ],
          title: 'Sydney Performance Scrub Jacket ',
        },
        {
          category: 'Socks',
          colors: [
            {
              handle: 'double-stripe-navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 2800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-navy-double-stripe-socks',
          priceRangeByColors: {},
          products: [
            {
              color: 'Double Stripe/Navy',
              handle: 'womens-double-stripe-compression-socks-navy',
              id: 'p4f40c9824da3a951',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Q1_2022_12_NAVY_COMPRESSIONSOCKS_W_GHOST_16712.jpg?v=1674076649',
                  },
                ],
              },
            },
          ],
          title: "Women's FIGS Compression Socks",
        },
        {
          category: 'Lab Coats',
          colors: [
            {
              handle: 'white',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 11800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-bellevue-long-slim-lab-coat',
          priceRangeByColors: {},
          products: [
            {
              color: 'White',
              handle: 'womens-bellevue-long-slim-lab-coat-white',
              id: 'p9d7229f958ced191',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Bellevue-Slim-Long-Lab-Coat_1.jpg?v=1650310328',
                  },
                ],
              },
            },
          ],
          title: 'Bellevue Slim Long Lab Coat',
        },
        {
          category: 'Outerwear',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 9800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-on-shift-outerwear',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-on-shift-fleece-jacket-black',
              id: 'p651876d30a34f562',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/W_ON_Shift_Fleece_Black_Updated_Backgrounds_20221.jpg?v=1650313615',
                  },
                ],
              },
            },
          ],
          title: 'On-Shift™ Fleece Jacket',
        },
        {
          category: 'Accessories',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'unisex-new-canvas-tote-accessories',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'unisex-new-canvas-tote-black',
              id: 'pa7d269c5133a081c',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/U-Tote-Black-1.jpg?v=1665521961',
                  },
                ],
              },
            },
          ],
          title: 'Canvas Tote',
        },
        {
          category: 'Scrub Cap',
          colors: [
            {
              handle: 'black',
            },
            {
              handle: 'navy',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 1800,
                currency: 'USD',
              },
            },
          },
          handle: 'unisex-modern-classic-scrub-cap-scrub-cap',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'unisex-modern-classic-scrub-cap-black',
              id: 'p0b233732790a1a6f',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Black.jpg?v=1678738853',
                  },
                ],
              },
            },
            {
              color: 'Navy',
              handle: 'unisex-modern-classic-scrub-cap-navy',
              id: 'p7fad172b6202dbeb',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Modern-Classic-Scrub-Cap-navy-1.jpg?v=1678722631',
                  },
                ],
              },
            },
          ],
          title: 'Modern Scrub Cap',
        },
        {
          category: 'Underscrub',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 3800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-super-soft-longsleeve-under-scrubs',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-super-soft-longsleeve-black',
              id: 'pac5abe5bb529841c',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-SuperSoftLongSleeve-Black-XL-1.jpg?v=1674518306',
                  },
                ],
              },
            },
          ],
          title: 'Supersoft - Longsleeve Underscrub',
        },
        {
          category: 'Scrub Jacket',
          colors: [
            {
              handle: 'black',
            },
          ],
          defaultVariant: {
            priceDetails: {
              discountPrice: {
                amount: null,
              },
              price: {
                amount: 8800,
                currency: 'USD',
              },
            },
          },
          handle: 'womens-bellery-scrub-jacket',
          priceRangeByColors: {},
          products: [
            {
              color: 'Black',
              handle: 'womens-bellery-scrub-jacket-black',
              id: 'p60d726bb5fa9290c',
              images: {
                nodes: [
                  {
                    source:
                      'https://cdn.shopify.com/s/files/1/0139/8942/products/Womens-Bellery-Scrub-JKT_black-1.jpg?v=1650312343',
                  },
                ],
              },
            },
          ],
          title: "Women's Bellery - Scrub Jacket",
        },
      ],
    },
  },
}
